import Home from '../templates/Home';
export default Home;
